<p-dialog header="回傳TMS" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)"
  [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '80%' }">


  <h2>Booking 單號：{{ booking?.bookingNo }}</h2>

  <p-table class="datatable" [value]="tmsData" [columns]="columns"    >

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{col.header}}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns" >
      <tr>
        <td>{{rowData.doNo}}</td>
        <td>{{rowData.message}}</td>
        <td>{{rowData.errorMessage}}</td>
        <td>{{rowData.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</td>
      </tr>
    </ng-template>


  </p-table>




</p-dialog>
